import { useEffect, useState } from "react";
import * as React from "react";
import { Button, Tooltip } from "antd";
import { usePlaceholderPopupStore } from "@/state/placeholderPopupStore";
// import { seedLocalStorage } from "@/mocks/testData";

type LibraryItem = {
  key: "line" | "column";
  image: string;
  title: string;
  subtitle: string;
};

const ITEMS: LibraryItem[] = [
  {
    key: "line",
    image: "/assets/linechart.png",
    title: "Line Chart",
    subtitle:
      "Displays share price on a daily basis over a selected time period for a primary company/index and selected peers.",
  },
  {
    key: "column",
    image: "/assets/columnchart.png",
    title: "Column Chart",
    subtitle:
      "Displays share price performance between two selected time periods for a primary company and selected peers. ",
  },
];

const ImageButton: React.FC<{
  item: LibraryItem;
  selected: boolean;
  onClick: () => void;
}> = ({ item, selected, onClick }) => {
  const [isSelected, setIsSelected] = useState(selected);
  useEffect(() => setIsSelected(selected), [selected]);

  const style: React.CSSProperties = {
    width: 300,
    marginTop: "20px",
    marginBottom: "20px",
    borderRadius: "8px",
    border: isSelected ? "2px solid #ff5c35" : "2px solid #808080",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    cursor: "pointer",
    overflow: "hidden",
  };

  const truncated = item.subtitle.length > 100 ? item.subtitle.slice(0, 100).trim() + "..." : item.subtitle;

  return (
    <div style={style} onClick={onClick}>
      <img alt={item.title} src={item.image} style={{ width: "100%", height: 160, objectFit: "cover" }} />
      <div style={{ padding: "12px" }}>
        <div style={{ fontWeight: 600, marginBottom: 8 }}>{item.title}</div>
        <Tooltip title={item.subtitle}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              textOverflow: "ellipsis",
              height: "4.5em",
              lineHeight: "1.5em",
              whiteSpace: "normal",
              wordBreak: "break-word",
            }}
          >
            {truncated}
          </div>
        </Tooltip>
      </div>
    </div>
  );
};

const ContentLibrary: React.FC = () => {
  const [selected, setSelected] = useState<LibraryItem["key"] | null>(null);
  const { setSelectedContent, setShowSidebar, setFromPlaceholderPopup } = usePlaceholderPopupStore();

  return (
    <div className="px-4 py-6">
      <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
        {ITEMS.map((it) => (
          <ImageButton key={it.key} item={it} selected={selected === it.key} onClick={() => setSelected(it.key)} />
        ))}
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 16 }}>
        {/* <Button
          onClick={() => {
            try {
              seedLocalStorage();
              Office?.context?.ui?.messageParent("INSERT_CHART");
            } catch (e) {}
          }}
        >
          Insert with Dummy Data
        </Button> */}
        <Button
          type="primary"
          disabled={!selected}
          onClick={() => {
            try {
              if (selected) localStorage.setItem("placeholderSelectedChartType", selected);
            } catch (e) {}
            if (selected === "line") {
              setFromPlaceholderPopup(true);
              setSelectedContent("line");
              setShowSidebar(false);
            }
          }}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default ContentLibrary;
